let cleanup = null
let stableLayoutHeight = 0

function px(value) {
  return `${Math.max(0, Math.round(Number(value) || 0))}px`
}

export function installAppViewport() {
  if (cleanup || typeof window === "undefined" || typeof document === "undefined") return cleanup || (() => {})
  const root = document.documentElement
  const viewport = window.visualViewport
  const isIOS = /iP(?:hone|ad|od)/i.test(window.navigator.userAgent || "")
    || (window.navigator.platform === "MacIntel" && Number(window.navigator.maxTouchPoints || 0) > 1)

  root.classList.toggle("ios-device", isIOS)
  if (document.body) document.body.classList.toggle("ios-device", isIOS)

  const update = () => {
    const visualHeight = viewport ? viewport.height : window.innerHeight
    const offsetTop = viewport ? viewport.offsetTop : 0
    const currentLayoutHeight = Math.max(window.innerHeight, visualHeight + offsetTop)
    if (!stableLayoutHeight) stableLayoutHeight = currentLayoutHeight
    const activeElement = document.activeElement
    const editableFocused = Boolean(activeElement && activeElement.matches && activeElement.matches("input,textarea,select,[contenteditable='true']"))
    const keyboardHeight = Math.max(0, stableLayoutHeight - visualHeight - offsetTop, window.innerHeight - visualHeight - offsetTop)
    const keyboardOpen = editableFocused && keyboardHeight >= 120
    if (!keyboardOpen) stableLayoutHeight = currentLayoutHeight
    root.style.setProperty("--app-viewport-height", px(visualHeight))
    root.style.setProperty("--layout-viewport-height", px(stableLayoutHeight))
    root.style.setProperty("--visual-viewport-offset-top", px(offsetTop))
    root.style.setProperty("--keyboard-height", px(keyboardHeight))
    root.classList.toggle("keyboard-open", keyboardOpen)
    if (document.body) document.body.classList.toggle("keyboard-open", keyboardOpen)
    window.dispatchEvent(new CustomEvent("starlive:viewport-change", {
      detail: { height: visualHeight, offsetTop, keyboardHeight, keyboardOpen }
    }))
  }

  window.addEventListener("resize", update, { passive: true })
  window.addEventListener("orientationchange", update, { passive: true })
  if (viewport) {
    viewport.addEventListener("resize", update, { passive: true })
    viewport.addEventListener("scroll", update, { passive: true })
  }
  update()

  cleanup = () => {
    window.removeEventListener("resize", update)
    window.removeEventListener("orientationchange", update)
    if (viewport) {
      viewport.removeEventListener("resize", update)
      viewport.removeEventListener("scroll", update)
    }
    root.classList.remove("keyboard-open", "ios-device")
    if (document.body) document.body.classList.remove("keyboard-open", "ios-device")
    cleanup = null
    stableLayoutHeight = 0
  }
  return cleanup
}
